<template>
  <div class=" widget-calendar">
    <dashboardCard heading="Caches" :data1="cacheGets" :data2="cachePuts" :data3="cacheRemovals"></dashboardCard>
  </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
  name: "cacheDetail",
  components: {
    dashboardCard
  },
  data() {
    return {
      cacheGets: {},
      cachePuts: {},
      cacheRemovals: {},
    };
  },
  methods: {
    getCacheGets(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.cacheGets.value = response.server.data[0].value;
          this.cacheGets.name = 'Gets'
          this.cacheGets.description = 'Number of times data is retrieved from the cache'
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCachePuts(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.cachePuts.value = response.server.data[0].value;
          this.cachePuts.name = 'Puts';
          this.cachePuts.description = 'Number of times data is added/updated in cache';
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCacheRemovals(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.cacheRemovals.value = response.server.data[0].value;
          this.cacheRemovals.name = 'Removals';
          this.cacheRemovals.description = 'Number of times data is removed from the cache'
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getCacheGets("CACHE_GETS");
    this.getCachePuts("CACHE_PUTS");
    this.getCacheRemovals("CACHE_REMOVALS");
  }
};
</script>